import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        customer: {},
        lstCustomer: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Cliente', key: 'document', align: 'center' },
            { title: 'Nome', key: 'customerName', align: 'center' },
            { title: 'Apelido', key: 'tradeName', align: 'center' },
            { title: 'Cidade', key: 'city', align: 'center' },
            { title: 'Estado', key: 'state', align: 'center' },
        ],
        lstStates: [
            { uf: 'AC', name: 'Acre' },
            { uf: 'AL', name: 'Alagoas' },
            { uf: 'AP', name: 'Amapá' },
            { uf: 'AM', name: 'Amazonas' },
            { uf: 'BA', name: 'Bahia' },
            { uf: 'CE', name: 'Ceará' },
            { uf: 'DF', name: 'Distrito Federal' },
            { uf: 'ES', name: 'Espírito Santo' },
            { uf: 'GO', name: 'Goiás' },
            { uf: 'MA', name: 'Maranhão' },
            { uf: 'MT', name: 'Mato Grosso' },
            { uf: 'MS', name: 'Mato Grosso do Sul' },
            { uf: 'MG', name: 'Minas Gerais' },
            { uf: 'PA', name: 'Pará' },
            { uf: 'PB', name: 'Paraíba' },
            { uf: 'PR', name: 'Paraná' },
            { uf: 'PE', name: 'Pernambuco' },
            { uf: 'PI', name: 'Piauí' },
            { uf: 'RJ', name: 'Rio de Janeiro' },
            { uf: 'RN', name: 'Rio Grande do Norte' },
            { uf: 'RS', name: 'Rio Grande do Sul' },
            { uf: 'RO', name: 'Rondônia' },
            { uf: 'RR', name: 'Roraima' },
            { uf: 'SC', name: 'Santa Catarina' },
            { uf: 'SP', name: 'São Paulo' },
            { uf: 'SE', name: 'Sergipe' },
            { uf: 'TO', name: 'Tocantins' }
        ]
    },
    getters: {
        getCustomer(state) {
            let customer = { ...state.customer }
            return customer
        }
    },
    mutations: {
        setCustomer(state, customer) {
            state.customer = customer
        },
        setLstCustomer(state, lstCustomer) {
            state.lstCustomer = lstCustomer
        },
        appendLstCustomer(state, items) {
            state.lstCustomer = [...state.lstCustomer, ...items]
        },
        clearLstCustomer(state) {
            state.lstCustomer = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.customer = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        },
        setAddressByZipCode(state, data) {
            state.customer = { 
                ...state.customer, 
                address: data.logradouro, 
                city: data.localidade, 
                state: data.uf, 
                complement: data.complemento, 
                district: data.bairro 
            }
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Customer/Insert',
                getters.getCustomer
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Cliente salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Customer/Update',
                getters.getCustomer
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Cliente atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Customer/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstCustomer", response.data.items)
            } else {
                commit("appendLstCustomer", response.data.items)
            }
            
            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, customerId) {
            const response = await api.get(
                `/Customer/Find/${customerId}`,
            )
            commit('setCustomer', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Customer/FindAll/`,
            )
            commit('setLstCustomer', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Customer/Delete/${getters.getCustomer.customerId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        },

        async searchCep({ getters, commit }) {
            const response = await api.get(`/ViaCep/SearchCep?zipcode=${getters.getCustomer.zipCode}`)

            commit('setAddressByZipCode', response.data)
            
            return true
        }
    }
}